/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertStatusEvent,
    InternalApiAlertStatusEventFromJSON,
    InternalApiAlertStatusEventToJSON,
    InternalApiAlertStatusUpdate,
    InternalApiAlertStatusUpdateFromJSON,
    InternalApiAlertStatusUpdateToJSON,
    InternalApiAlertType,
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeToJSON,
} from '../models';

export interface GetAllAlertStatusUpdatesRequest {
    alertId: number;
    alertType: InternalApiAlertType;
}

export interface UpdateAlertStatusRequest {
    internalApiAlertStatusUpdate: InternalApiAlertStatusUpdate;
}

/**
 * 
 */
export class AlertStatusApi extends runtime.BaseAPI {

    /**
     * Get all alert status events for alert
     */
    async getAllAlertStatusUpdatesRaw(requestParameters: GetAllAlertStatusUpdatesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiAlertStatusEvent>>> {
        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
            throw new runtime.RequiredError('alertId','Required parameter requestParameters.alertId was null or undefined when calling getAllAlertStatusUpdates.');
        }

        if (requestParameters.alertType === null || requestParameters.alertType === undefined) {
            throw new runtime.RequiredError('alertType','Required parameter requestParameters.alertType was null or undefined when calling getAllAlertStatusUpdates.');
        }

        const queryParameters: any = {};

        if (requestParameters.alertId !== undefined) {
            queryParameters['alertId'] = requestParameters.alertId;
        }

        if (requestParameters.alertType !== undefined) {
            queryParameters['alertType'] = requestParameters.alertType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiAlertStatusEventFromJSON));
    }

    /**
     * Get all alert status events for alert
     */
    async getAllAlertStatusUpdates(requestParameters: GetAllAlertStatusUpdatesRequest, initOverrides?: RequestInit): Promise<Array<InternalApiAlertStatusEvent>> {
        const response = await this.getAllAlertStatusUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update status for alert
     */
    async updateAlertStatusRaw(requestParameters: UpdateAlertStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiAlertStatusUpdate === null || requestParameters.internalApiAlertStatusUpdate === undefined) {
            throw new runtime.RequiredError('internalApiAlertStatusUpdate','Required parameter requestParameters.internalApiAlertStatusUpdate was null or undefined when calling updateAlertStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAlertStatusUpdateToJSON(requestParameters.internalApiAlertStatusUpdate),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update status for alert
     */
    async updateAlertStatus(requestParameters: UpdateAlertStatusRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateAlertStatusRaw(requestParameters, initOverrides);
    }

}
